import { IFeature } from 'mod/featureV2/interface';

const image = {
    bgColor: '#e6e8e5',
    src: 'asset/width-3840/picture/eba58330bfafdde773c90779dd8973e1.png',
    href: '/vivosun-smart-grow-box?mock=1',
    alt: 'test',
    subtitle: 'Smart Grow Box',
    title: 'Fits Anywhere',
    description: 'High-quality growing in a compact design. Ideal for any space.',
}

const video = {
    bgcolor: '#141414',
    src: 'file-asset/file/62205f7a09e5dc4661cdcd6640e32305/1703665032125/output.m3u8',
    poster: 'asset/width-3840/picture/6407c9150a111a6a0c7080a257d497ff.jpg',
    subtitle: 'Smart Grow Box',
    title: 'Fits Anywhere',
    description: 'Video banners with overlay cannot control playback.',
}

export const overlayBanner: IFeature = {
    moduleId: 'overlayBanner',
    type: 'overlayBanner',
    title: 'overlayBanner',
    description: 'description',
    config: {
        width: 3840,
        // height: 1860,
        height: 3840,
        column: 3,
        fullScreen: true,
        sideSpace: false,
        largeScreenHeightFixed: true,
        bgColor: '#F1F0ED',
    },
    list: [
        {
            ...image,
            title: 'default values',
            description: 'align: left, positonX: left, positonY: mdidle',
        },
        {
            ...image,
            title: 'align and positon',
            overlay: {
                align: 'left',
                positonX: 'left',
                positonY: 'middle',
            }
        },

        {
            ...image,
            title: 'align and positon',
            overlay: {
                align: 'right',
                positonX: 'right',
                positonY: 'bottom',
            }
        },
        {
            ...image,
            title: 'adjust top spacing',
            overlay: {
                positonY: 'top',
                style: {
                    marginTop: '1%'
                }
            }
        },
        {
            ...image,
            title: 'adjust middle spacing',
            overlay: {
                positonY: 'middle',
                style: {
                    paddingBottom: '30%'
                }
            }
        },
        {
            ...image,
            title: 'adjust bottom spacing',
            overlay: {
                positonY: 'bottom',
                style: {
                    marginBottom: '1%'
                }
            }
        },
        {
            ...image,
            title: 'complex configuration',
            overlay: {
                positonY: 'middle',
                style: {
                    maxWidth: '80%',
                    background: 'rgba(255, 255, 255, .6)',
                    padding: 20,
                    borderRadius: 8,
                    color: '#4288b2',
                    fontSize: 20,
                }
            }
        },
        {
            ...video,
            title: 'video loop=true',
            loop: true,
        },
        {
            ...video,
            title: 'video loop=false',
            href: '/vivosun-smart-grow-box?mock=1',
        },
    ]
};